import { permissionGuard } from "@/auth/permissionAuthGuard";
import { NavigationCategoryEnum } from "@/store/enum/navigationCategoryEnum";
import { ICustomRouteConfig } from "@/store/interface/custom.route.config.interface";
import AuthorizationOverview from "@/views/AuthorizationOverview.vue";
import NoRoles from "@/views/NoRoles.vue";
import Profile from "@/views/Profile.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import { enrichRouteMeta } from "./utils/enrichRouteMeta";

Vue.use(VueRouter);

export const routes: ICustomRouteConfig[] = [
  {
    path: "/",
    name: "Profile",
    component: Profile,
    navigation: {
      category: NavigationCategoryEnum.SETTINGS,
      icon: "mdi-account-outline",
      isEnabled: true,
      isSideBarNavigation: false,
      isQuickLink: true,
      isProfileMenu: true,
      priority: 100
    }
  },
  {
    path: "/permissions",
    name: "Permissions",
    component: AuthorizationOverview
  },
  {
    path: "/no-roles",
    name: "NoRoles",
    component: NoRoles
  }
];

const router = new VueRouter({
  routes: enrichRouteMeta(routes),
  base: "/"
});

router.beforeEach(permissionGuard);

export default router;
